/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    currentSelection?: unknown;
  };
}

import Component from "@glimmer/component";

import styles from "./index.module.css";
export default class extends Component<Signature> {
  styles = styles;
}
